import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatPaginator, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TipoDeLogAcesso } from 'src/app/models/enum';
import { Filtro } from 'src/app/models/filtro';
import { LogAcesso } from 'src/app/models/log-acesso';
import { Marca } from 'src/app/models/marca';
import { ItemPedido } from 'src/app/models/pedido';
import { Produto } from 'src/app/models/produto';
import { CarregandoService } from 'src/app/services/carregando.service';
import { LogAcessoService } from 'src/app/services/log-acesso.service';
import { MarcaService } from 'src/app/services/marca.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { GlobalService } from 'src/app/services/global.service';
import { EstruturasPersonalizadas } from 'src/app/models/estruturas-personalizadas';

@Component({
  selector: 'app-seleciona-kit-modal',
  templateUrl: './seleciona-kit-modal.component.html',
  styleUrls: ['./seleciona-kit-modal.component.scss']
})
export class SelecionaKitModalComponent implements OnInit {
  produtos: any[] = [];
  itens: any[];
  kits: any[] = [];
  producaoPorPainel;
  quantidadeDePaineis;
  potenciaPainel;
  potTotal;
  potenciaParaFiltrar = 0;
  potenciaParaFiltrarPainel = 0;
  itensFiltrados: ItemPedido[] = [];
  public config: PerfectScrollbarConfigInterface = {};
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  carregando = true;
  listaDeItensPorPagina = [];
  itensPorPagina = 9;
  filtroNome: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtroCodBarra: Filtro = { Propriedade: 'codbarra', Valor: '' };
  filtroFamilia: Filtro = { Propriedade: 'familia', Valor: '' };
  filtros: Filtro[] = [this.filtroNome, this.filtroCodBarra];
  potenciaAte: number;
  multiFornecedores = false;
  idProduto;
  marcasPainel: Marca[] = [];
  marcasInversor: Marca[] = [];
  marcaPainelSelecionada;
  marcaInversorSelecionada;
  telhados: any[] = [];
  telhadoSelecionado;
  ordenacoes = [{ id: 0, nome: 'Mais vendidos' }, { id: 1, nome: 'Maior valor' }, { id: 2, nome: 'Menor valor' }];
  ordenacaoSelecionada = 2;
  visualizacaoSelecionada = 0;
  usarCentroDeDistribuicao = false;
  bloquearSistema: boolean = false;
  administrador: boolean = false;

  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(public dialogRef: MatDialogRef<SelecionaKitModalComponent>,
    private logAcessoService: LogAcessoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private marcaService: MarcaService,
    private notificacaoService: NotificacaoService,
    private produtoService: ProdutoService,
    public utilitarioService: UtilitarioService,
    private premissasService: PremissasService,
    private pedidoService: PedidoService,
    private globalService: GlobalService) {
    this.potenciaParaFiltrar = data.potTotal;
    this.potenciaAte = data.potenciaAte;
    this.itens = data.itens;
    this.multiFornecedores = data.multiFornecedores;
    this.idProduto = data.idProduto;
  }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();
    this.listarMarcasPainel();
    this.listarMarcasInversor();
    this.buscarUsarTelhadoCeramico();
    this.buscarProdutos();
    this.buscarUsarCentroDeDistribuicao();
  }

  buscarPremissasBloqueioSistema() {
    this.carregandoService.mostra('buscarBloqSist');
    this.premissasService.consultarBloqSistManuProd().subscribe(data => {
      this.bloquearSistema = data;
      this.carregandoService.esconde('buscarBloqSist');
    }, (erro) => {
      this.carregandoService.esconde('buscarBloqSist');
      this.notificacaoService.erro(erro);
    });
  }

  buscarUsarTelhadoCeramico() {

    this.carregandoService.mostra('consultarEstruturasPersonalizadas');
    this.premissasService.consultarEstruturasPersonalizadas().subscribe(
      (dados) => {

        this.estruturasPersonalizadas = dados;

        this.carregandoService.mostra('consultarUsarTelCeramico');
        this.premissasService.consultarUsarTelCeramico().subscribe(
          (f) => {

            this.telhados = [];

            if (f.valor) {
              this.telhados = [
                ...[
                  { id: 0, nome: 'Cerâmico' },
                  { id: 1, nome: 'Fibrocimento' },
                  { id: 8, nome: this.estruturasPersonalizadas.textoFibrometal },
                  { id: 4, nome: 'Metálico' },
                  { id: 7, nome: 'Mini trilho ' },
                  { id: 5, nome: 'Laje' },
                  { id: 6, nome: 'Solo' },
                ],
              ];
            } else {
              this.telhados = [
                ...[
                  { id: 9, nome: 'Colonial' },
                  { id: 10, nome: 'Romana/Americana' },
                  { id: 1, nome: 'Fibrocimento' },
                  { id: 8, nome: this.estruturasPersonalizadas.textoFibrometal },
                  { id: 4, nome: 'Metálico' },
                  { id: 7, nome: 'Mini trilho ' },
                  { id: 5, nome: 'Laje' },
                  { id: 6, nome: 'Solo' },
                ],
              ];
            }

            if (this.estruturasPersonalizadas.usarEstruturaCalhetao) {
              this.telhados.push({ id: 12, nome: this.estruturasPersonalizadas.textoEstruturaCalhetao });
            }

            if (this.estruturasPersonalizadas.usarEstruturaCarport) {
              this.telhados.push({ id: 13, nome: this.estruturasPersonalizadas.textoEstruturaCarport });
            }

            this.carregandoService.esconde('consultarUsarTelCeramico');
          },
          (erro) => {
            this.carregandoService.esconde('consultarUsarTelCeramico');
            this.notificacaoService.erro(erro);
          }
        );

        this.carregandoService.esconde('consultarEstruturasPersonalizadas');
      },
      (erro) => {
        this.carregandoService.esconde('consultarEstruturasPersonalizadas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  listarMarcasPainel() {
    this.carregandoService.mostra('listarMarcasPainel');

    this.marcaService.listarPorFamilia(2).subscribe(
      (marcs) => {
        this.marcasPainel = marcs;
        this.carregandoService.esconde('listarMarcasPainel');
      },
      (erro) => {
        this.carregandoService.esconde('listarMarcasPainel');
        this.notificacaoService.erro(erro);
      }
    );
  }

  listarMarcasInversor() {
    this.carregandoService.mostra('listarMarcasInversor');

    this.marcaService.listarPorFamilia(3).subscribe(
      (marcs) => {
        this.marcasInversor = marcs;
        this.carregandoService.esconde('listarMarcasInversor');
      },
      (erro) => {
        this.carregandoService.esconde('listarMarcasInversor');
        this.notificacaoService.erro(erro);
      }
    );
  }

  abrirKit(kit: any) {
    kit.kitAberto = true;
  }

  alterarVisualizacao() {
    this.visualizacaoSelecionada = this.visualizacaoSelecionada ? 0 : 1;
  }

  buscarProdutos() {

    this.gerarLogAcesso();

    this.carregandoService.mostra('buscaProduto');
    this.carregando = true;



    this.produtoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      'pesoliq,precovenda', this.ordenarDesc ? 'desc' : 'asc', null, '', 'A', '7', true, null, null, null, this.potenciaParaFiltrar * 1000, this.potenciaAte * 1000, null, this.multiFornecedores, this.idProduto ? this.idProduto : null, this.marcaPainelSelecionada, this.marcaInversorSelecionada, this.telhadoSelecionado, this.ordenacaoSelecionada, null, null, null, null, null, null, null, null, null, 'A').subscribe(dados => {

      const produtos: Produto[] = dados.itens;

      this.itensFiltrados = [];

      produtos.forEach(p => {
        const novoItem = new ItemPedido();
        novoItem.pUnitario = p.precoVenda;
        novoItem.pCusto = p.precoCusto;
        novoItem.produto = p.idProduto;
        novoItem.produtoTela = p;
        novoItem.det1 = p.descricaoAtual;

        this.itensFiltrados.push(novoItem);
      });

      this.itensFiltrados.forEach((kit: ItemPedido) => {
        kit.imagem$ = this.buscarImagemProduto(kit.produtoTela.idProduto);
        kit.imagem$.then(p => { kit.buscouImagem = true; });
      });
      // this.atualizaProdutos();

      this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(dados.total);

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      if (this.idProduto) {
        if (this.itensFiltrados.length > 0) {
          this.itensFiltrados[0].qt = 1;
        }

        this.dialogRef.close(this.itensFiltrados);
      }

      this.carregando = false;
      this.carregandoService.esconde('buscaProduto');


    }, (erro) => {
      this.carregandoService.esconde('buscaProduto');
    });
  }

  async buscarImagemProduto(idProduto: number): Promise<string> {
    const imagem = await this.produtoService.consultarImagemProdutoPorId(idProduto).toPromise();

    if (imagem && imagem.url) {
      return Promise.resolve(imagem.url);
    } else if (imagem && imagem.raw) {
      return Promise.resolve('data:image/jpg;base64,' + imagem.raw);
    } else {
      return Promise.resolve('./assets/img/inversor.png');
    }
  }

  selecionarProduto(produto?) {
    produto.qt = 1;
    this.dialogRef.close([...this.itens, produto]);
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarProdutos();
  }

  validarPotencias() {
    if (
      this.potenciaParaFiltrar !== null &&
      this.potenciaParaFiltrar !== undefined &&
      this.potenciaAte !== null &&
      this.potenciaAte !== undefined
    ) {
      if (Number(this.potenciaParaFiltrar) > Number(this.potenciaAte)) {
        this.notificacaoService.erro(
          'A Potência De deve ser menor que a Potência Até.'
        );
        this.potenciaAte = this.potenciaParaFiltrar;
      }
    }
  }

  gerarLogAcesso() {
    const logAcesso: LogAcesso = {
      tipo: TipoDeLogAcesso.KitPronto,
      potenciaDe: Number(this.potenciaParaFiltrar),
      potenciaAte: Number(this.potenciaAte),
    };

    this.logAcessoService.Salvar(logAcesso).subscribe(() => { });
  }

  buscarUsarCentroDeDistribuicao() {

    this.carregandoService.mostra('consultarCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      (f) => {
        this.usarCentroDeDistribuicao = f.valor;



        this.carregandoService.esconde('consultarCentroDeDistribuicao');
      },
      (erro) => {
        this.carregandoService.esconde('consultarCentroDeDistribuicao');
        this.notificacaoService.erro(erro);
      }
    );
  }

}
